import "./PanelFrame.scss";

const PanelFrame = ({
  title,
  children,
  className = "",
  headerRight = null,
  id,
}) => {
  return (
    <section className={`mu-panel ${className}`} id={id}>
      {(title || headerRight) && (
        <header className="mu-panel__header">
          {title ? <h2 className="mu-panel__title">{title}</h2> : <span />}
          {headerRight}
        </header>
      )}
      <div className="mu-panel__body">{children}</div>
    </section>
  );
};

export default PanelFrame;
